import styled from "styled-components/macro";
import { Typography } from "@mui/material";

export const AutocompleteListItem = styled.li`
  font-size: 11px;
  font-weight: 500;
`;

export const AutocompleteAreaName = styled(Typography)`
  display: block;
`;

export const AutocompletePropertyName = styled(Typography)`
  font-size: 12px;
  color: #b0bec5;
  display: block;
`;
